export const LOCALSTORAGE_TOKEN_NAME = 'tokenwebsitemonitorpanel';
export const LOCALSTORAGE_REFRESH_TOKEN_NAME = 'refreshtokenwebsitemonitorpanel'
export const LOCALSTORAGE_TOKEN_EXPIRE_TIME = 'tokenwebsitemonitorpanelexpire'
export const LOCALSTORAGE_TOKEN_REFRESHING = 'isTokenRefreshingWebsiteMonitor';